// Redirect user to login if token not found
export const checkAuth = () => {
  const token = localStorage.getItem("authToken");

  if (!token || token === "null" || token === "undefined") {
    window.location.href = "/login";   // Redirect
    return null;
  }

  return token; // return token if exists
};
